import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

import play from './play.js';
export default new Vuex.Store({
    state: {
        livehasStart:false,
        warmhasStart:false,
        playcodeNum:0,
        livecanComment:false,
        //显示人数
        showPeopleFlag:false,
        userId:'',
        userPlatfromType:'',
        drawPanelShow:true,//控制文档tab是否显示
        coursewarePPT:true,
        isPushFlow: false,
        isPlayerFinish:false,//录播cc播放器是否加载完成
    },
    mutations: {
        changelivestart(state,val){
            state.livehasStart = val.livehasStart;
            state.warmhasStart = val.warmhasStart;
        },
        needplayCode(state){
            state.playcodeNum++;
        },
        livecanComment(state){
            state.livecanComment = true;
        },
        showPeopleFlag(state,val){
            state.showPeopleFlag = val;
        },
        getUserId(state,val){
            state.userId = val.userId;
            state.userPlatfromType = val.userPlatfromType;
        },
        changedrawPanelShow(state,val){
            state.drawPanelShow = val;
        },
        changePushFlow(state, val) {
            state.isPushFlow = val;
        },
        hasCourseware(state,val){
            state.coursewarePPT = val;
        },
        changePlayerFinish(state,val){
            state.isPlayerFinish = val;
        }
    },
    actions: {

    },
    modules: {
        play
    }
  })


// WEBPACK FOOTER //
// ./src/cmtapp/store/index.js